var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":'查看供应商报价',"append-to-body":true,"close-on-click-modal":false,"width":"80%","visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('part-price-tab',{ref:"partPriceTab",attrs:{"vender":_vm.vender,"dataForm":_vm.dataForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }